import React, { Component } from 'react';
import {
  Button,
  TableHeader,
  TableHead,
  DataTable,
  Tabs,
  DataTableSkeleton,
  Tab,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TextInput,
  TableToolbar,
  InlineLoading,
  RadioButtonGroup,
  RadioButton,
  CodeSnippetSkeleton,
  FormGroup,
  TextArea,
} from 'carbon-components-react';
import '../../scss/custom.scss';
import Info16 from '@carbon/icons-react/lib/information/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import moment from 'moment';
import SimpleReactValidator from 'simple-react-validator';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { api } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getError, entitiesLabels, apioperation, getSuccess } from '../../helpers/Constants';
import { AppContext } from '../../helpers/context/AppContext';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { WarningModal } from '../common/WarningModal';
import { HistoryTable } from '../../helpers/HistoryTable';
import ReportRepository from '../../helpers/api/ReportRepository';
import EnergyAccountLeasedAssetList from '../report/EnergyAccountLeasedAssetList';

export default class Enviroment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stateDivForm: false,
      stateDivDownload: false,
      isOpenInfo: false,
      isLoadingReport: true,
      isLoading: true,
      isSubmitted: true,
      isLoadingSubmitted: false,
      isWarningModalOpen: false,
      isHistoryModalOpen: false,
      isInvalid: false,
    };
    this.showDivInfo = this.showDivInfo.bind(this);

    this.geqValidator = {
      message: 'The value must be greater than or equal to zero',
      rule: (val, params, validator) => {
        return +val >= 0;
      },
    };
    this.validator = new SimpleReactValidator({
      validators: {
        geq: this.geqValidator,
      },
    });
    this.validations = {};
  }

  showDivInfo() {
    this.setState((oldState) => ({ isOpenInfo: !oldState.isOpenInfo }));
  }

  divInfo() {
    return (
      <div className=" box--informations-all">
        <div
          className={
            !this.state.isOpenInfo ? 'bx--row box--information' : 'bx--row box--information show'
          }
        >
          <div className="bx--col-lg-4 bx--col-md-4 box-information-detail-skeleton">
            <div className="information--itmes">
              <div className="information--color ">Start:</div>
              <div className="notification-module">
                {moment.utc(this.state.report.start).format('DD/MM/YYYY')}
              </div>{' '}
            </div>
          </div>
          <div className="bx--col-lg-4 bx--col-md-4 box-information-detail-skeleton">
            <div className="information--itmes">
              <div className="information--color ">End:</div>
              <div className="notification-module">
                {moment.utc(this.state.report.end).format('DD/MM/YYYY')}
              </div>{' '}
            </div>
          </div>
          <div className="bx--col-lg-4 bx--col-md-4 box-information-detail-skeleton">
            <div className="information--itmes">
              <div className="information--color ">Compiled by:</div>
              <div className="notification-module">{this.state.report.compiledBy}</div>{' '}
            </div>
          </div>
        </div>
      </div>
    );
  }

  showButtonHistory = () => {
    return (
      <Button
        className="action-button-modal"
        kind="secondary"
        renderIcon={Info16}
        onClick={() => this.openModalHistory()}
      >
        History
      </Button>
    );
  };
  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };

  showDivInfo = () => {
    this.setState((oldState) => ({ isOpenInfo: !oldState.isOpenInfo }));
  };

  // returns a 2d associative array-like data structure.
  // entries are rows and cols ids in the 'schema' innput
  buildTwoLevelStructure = (schema, init) => {
    let result = {};
    schema.rows.forEach((r) => {
      result[r.id] = {};
      schema.cols.forEach((c) => {
        result[r.id][c.id] = init ? {} : null;
      });
    });
    return result;
  };

  // returns a 3d associative array-like data structure.
  // entries are rows, cols and subcols ids in the input schema
  buildThreeLevelStructure = (schema) => {
    let result = {};
    schema.rows.forEach((r) => {
      result[r.id] = {};
      schema.cols.forEach((c) => {
        result[r.id][c.id] = {};
        schema.subCols.forEach((s) => {
          result[r.id][c.id][s.id] = null;
        });
      });
    });
    return result;
  };

  getEnvironmentReport = async () => {
    const [schema, report] = await Promise.all([
      ReportRepository.getEnvironmentSchema(this.props.match.params.idReport),
      ReportRepository.getReportEnvironment(this.props.match.params.idReport),
    ]).catch((error) => {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.ENVIROMENT, apioperation.GET)
      );
    });

    // build associative data structures: it makes referencing/updating their values
    // much esier in templates and change handlers.
    // pass true as the second parameter for multi-valued fields (e.g.: double measure unit)
    const waterBySource = this.buildTwoLevelStructure(schema.waterBySource, false);
    const waterDischarged = this.buildThreeLevelStructure(schema.waterDischarged, false);
    const waterReused = this.buildTwoLevelStructure(schema.waterReused, false);
    const hazardousWaste = this.buildTwoLevelStructure(schema.hazardousWaste, true);
    const nonHazardousWaste = this.buildTwoLevelStructure(schema.nonHazardousWaste, true);
    const energyBySource = this.buildTwoLevelStructure(schema.energyAccounting, false);
    const oilSpill = this.buildTwoLevelStructure(schema.oilSpill, true);
    const chemicalSpill = this.buildTwoLevelStructure(schema.chemicalSpill, true);

    // TODO - Seeding for waste monetization schema not available!
    let wasteMonetization = this.buildTwoLevelStructure(schema.wasteMonetization, true);

    report.waterSourceReportData &&
      report.waterSourceReportData.forEach((w) => {
        waterBySource[w.idWaterSourceType][w.idWaterUsageType] = w.valueM3;
      });
    report.waterDischargedReportData &&
      report.waterDischargedReportData.forEach((w) => {
        waterDischarged[w.idWaterSourceType][w.idWaterDischargeType][w.idWaterDischargeTreatment] =
          w.valueM3;
      });
    report.waterReusedReportData &&
      report.waterReusedReportData.forEach((w) => {
        waterReused[w.idWaterSourceType][w.idWaterUsageType] = w.valueM3;
      });
    report.wasteHazReportData &&
      report.wasteHazReportData.forEach((w) => {
        hazardousWaste[w.idWasteType][w.idWasteTreatment] = {
          m3: w.valueT !== 0 && w.valueM3 === 0 ? '' : w.valueM3,
          t: w.valueT,
        };
      });
    report.wasteNonHazReportData &&
      report.wasteNonHazReportData.forEach((w) => {
        nonHazardousWaste[w.idWasteType][w.idWasteTreatment] = {
          m3: w.valueT !== 0 && w.valueM3 === 0 ? '' : w.valueM3,
          t: w.valueT,
        };
      });
    report.energySourceReportData &&
      report.energySourceReportData.forEach((e) => {
          if(energyBySource.hasOwnProperty(e.idEnergySourceType)) // to accept new data and remove the unwanted  
            energyBySource[e.idEnergySourceType][e.idEnergyUsageType] = e.value;
      });
    report.oilSpillReportData &&
      report.oilSpillReportData.forEach((o) => {
        oilSpill[o.idSpillValueRange][o.idSpillDestination] = { n: o.valueN, m3: o.valueM3 };
      });
    report.chemicalSpillReportData &&
      report.chemicalSpillReportData.forEach((c) => {
        chemicalSpill[c.idSpillValueRange][c.idSpillDestination] = { n: c.valueN, m3: c.valueM3 };
      });
    report.wasteMonetizationReportData &&
      report.wasteMonetizationReportData.forEach((w) => {
        wasteMonetization[w.idWasteType][w.idWasteMonetization] = {
          m3: w.valueT !== 0 && w.valueM3 === 0 ? '' : w.valueM3,
          t: w.valueT,
          euro: w.valueEuro,
        };
      });

    // assign value to irrelevant fields, otherwise validation will fail
    // WARNING: this is a temporary ugly hack
    const informativeonlyIds = schema.energyAccounting.rows
      .filter((r) => r.informativeonly)
      .map((r) => r.id);
    informativeonlyIds.forEach((i) => {
      Object.keys(energyBySource[i]).forEach((key) => {
        energyBySource[i][key] = energyBySource[i][key] || 0;
      });
    });

    this.setState({
      schema,
      report,
      waterBySource,
      waterDischarged,
      waterReused,
      hazardousWaste,
      nonHazardousWaste,
      wasteMonetization,
      energyBySource,
      oilSpill,
      chemicalSpill,

      oilSpillExistentOilResponse: report.oilSpillExistentOilResponse,
      oilSpillNumberEnvSampling: report.oilSpillNumberEnvSampling,
      oilSpillRecoveredVolum: report.oilSpillRecoveredVolum,
      chemicalSpillNumberEnvSampling: report.chemicalSpillNumberEnvSampling,
      chemicalSpillRecoveredVolum: report.chemicalSpillRecoveredVolum,
      bottleWater: report.bottleWater,

      //Notes
      waterSourceNotes: report.waterSourceNotes,
      waterDischargedReusedNotes: report.waterDischargedReusedNotes,
      waterHazNotes: report.waterHazNotes,
      waterNonHazNotes: report.waterNonHazNotes,
      energySourceNotes: report.energySourceNotes,
      oilSpillNotes: report.oilSpillNotes,
      chemicalSpillNotes: report.chemicalSpillNotes,
      wasteMonetizationNotes: report.wasteMonetizationNotes,

      isLoading: false,
    });
  };

  componentDidMount() {
    this.getEnvironmentReport();
  }

  onSimpleInputChange = (field, e) => {
    const newState = {};
    newState[field] = e.target.value;
    this.setState(newState);
  };
  onReportNotesChange = (e) => {
    let newState = {};
    newState[e.target.id] = e.target.value;
    this.setState(newState);
  };
  handleRadioChange = (value, id, event) => {
    if (value === 'true') {
      value = true;
    } else if (value === 'false') {
      value = false;
    } else if (value === 'null') {
      value = null;
    }
    this.setState({
      oilSpillExistentOilResponse: value,
    });
    // this.updateState(id, value, event.target.alt);
  };

  onRowColInputChange = (tab, row, col, e) => {
    const newState = {};
    const newRow = { ...this.state[tab][row] };
    newRow[col] = e.target.value;
    const newStateEntry = { ...this.state[tab] };
    newStateEntry[row] = newRow;
    newState[tab] = newStateEntry;
    this.setState(newState);
  };

  onAutoConvertingInputChange = (tab, row, col, unit, e) => {
    // TODO - DO NOT mutate the state directly!

    if (unit === 'euro') {
      this.state[tab][row][col][unit] = +e.target.value;
    } else {
      const { density } = this.state.schema[tab].rows.filter((r) => r.id === row)[0];
      const conversionCoefficient = unit === 'm3' ? density : 1 / density;
      const targetUnit = unit === 'm3' ? 't' : 'm3';
      this.state[tab][row][col][unit] = +e.target.value;
      if (unit !== 't')
        this.state[tab][row][col][targetUnit] = +e.target.value * conversionCoefficient;
      if (unit === 't') {
        this.state[tab][row][col][targetUnit] = '';
      }
    }
    this.setState({});
  };

  onRowColSubcolInputChange = (tab, row, col, subcol, e) => {
    // TODO - DO NOT mutate the state directly!
    this.state[tab][row][col][subcol] = e.target.value;
    this.setState({});
  };

  renderWaterBySourceTab = () => {
    const waterBySourceHeaders = this.state.schema.waterBySource.cols.map((w) => ({
      key: w.id,
      header: w.name,
    }));
    waterBySourceHeaders.unshift(
      { key: 'label', header: 'Description' },
      { key: 'total', header: 'Total' }
    );

    const waterBySourceRows = this.state.schema.waterBySource.rows.map((r) => {
      let total = 0;
      this.state.schema.waterBySource.cols.forEach(
        (c) => (total += +this.state.waterBySource[r.id][c.id] || 0)
      );
      return { id: r.id, label: r.name, total };
    });

    const grandTotal = waterBySourceRows.map((w) => w.total).reduce((acc, cur) => (acc += cur), 0);

    const bottleWater = { id: 0, key: 'bottleWater', label: 'Bottle water (m³)' };
    const secondaryTableHeaders = [
      { key: 'key', header: '' },
      { key: 'label', header: '' },
    ];

    const validations = {};
    this.state.schema.waterBySource.rows.forEach((r) => {
      validations[r.id] = {};
      this.state.schema.waterBySource.cols.forEach((c) => {
        validations[r.id][c.id] = this.validator.message(
          `waterBySource${r.id}${c.id}`,
          this.state.waterBySource[r.id][c.id],
          'geq'
        );
      });
    });

    const rows = Object.keys(validations);
    const cols = Object.keys(validations[rows[0]]);
    let isValid = true;
    for (const r of rows) {
      for (const c of cols) {
        if (validations[r][c] != null) {
          isValid = false;
          break;
        }
      }
      if (!isValid) break;
    }
    validations.bottleWater = this.validator.message(
      'waterBySource' + 'BottleWater',
      this.state.bottleWater,
      'geq'
    );
    if (validations.bottleWater != null) isValid = false;

    return (
      <Tab disabled={false} label="Water withdrawal" className={isValid ? '' : 'with-error'}>
        <div className="datatable--information">
          <DataTable
            rows={waterBySourceRows || []}
            headers={waterBySourceHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? '' : 'align-center'}
                            {...getHeaderProps({ header })}
                          >
                            {header.header !== 'Description' ? (
                              <div>
                                {' '}
                                {header.header} <p> m³ </p>
                              </div>
                            ) : (
                              header.header
                            )}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        rows.map((row) => (
                          <TableRow {...getRowProps({ row })}>
                            <td className="bx--cell">{row.cells[0].value}</td>
                            <td className="bx--cell center-vertically right-align">
                              {Math.round(row.cells[1].value * 100) / 100}
                            </td>
                            {row.cells.slice(2).map((cell) => (
                              <td className="bx--cell-input" key={cell.id}>
                                <TextInput
                                  className="cell--item"
                                  value={this.state.waterBySource[row.id][cell.info.header]}
                                  onChange={(e) =>
                                    this.onRowColInputChange(
                                      'waterBySource',
                                      row.id,
                                      cell.info.header,
                                      e
                                    )
                                  }
                                  type="number"
                                  min="0"
                                  invalid={validations[row.id][cell.info.header] != null}
                                />
                                {validations[row.id][cell.info.header]}
                              </td>
                            ))}
                          </TableRow>
                        ))
                      )}
                      <TableRow>
                        <td
                          colSpan={waterBySourceHeaders.length + 2}
                          className="bx--cell grand-total"
                        >
                          <h4>
                            Total:
                            {Math.round(grandTotal * 100) / 100}
                          </h4>
                        </td>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information secondary">
          <DataTable
            rows={[bottleWater] || []}
            headers={secondaryTableHeaders || []}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        <>
                          {rows.map((row) => (
                            <TableRow {...getRowProps({ row })}>
                              <td className="bx--cell">{row.cells[1].value}</td>
                              <td className="bx--cell center-vertically right-align">
                                <TextInput
                                  className="cell--item"
                                  value={this.state[row.cells[0].value]}
                                  onChange={(e) => this.onSimpleInputChange(row.cells[0].value, e)}
                                  type="number"
                                  min="0"
                                  invalid={validations.bottleWater != null}
                                />
                                {validations.bottleWater}
                              </td>
                            </TableRow>
                          ))}
                        </>
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
          <div className="datatable--information notes">
            <FormGroup legendText="Notes">
              <TextArea
                maxLength={5000}
                id="waterSourceNotes"
                value={this.state.waterSourceNotes}
                onChange={this.onReportNotesChange}
                placeholder="Input Water Withdrawal Notes"
                hideLabel={true}
                labelText=""
                light
                rows={4}
                cols={100}
              />
            </FormGroup>
          </div>
        </div>
      </Tab>
    );
  };

  renderWaterDischargedReusedTab = () => {
    const waterDischargedHeaders = this.state.schema.waterDischarged.cols.map((c) => ({
      key: c.id,
      header: c.name,
    }));
    const waterDischargedRows = this.state.schema.waterDischarged.rows.map((r) => {
      let total = 0;
      this.state.schema.waterDischarged.cols.forEach((c) => {
        this.state.schema.waterDischarged.subCols.forEach((s) => {
          total += +this.state.waterDischarged[r.id][c.id][s.id] || 0;
        });
      });
      return { id: r.id, label: r.name, total };
    });

    const grandTotalDischarged = waterDischargedRows
      .map((w) => w.total)
      .reduce((acc, cur) => (acc += cur), 0);

    const waterDischargedSubHeaders = this.state.schema.waterDischarged.cols
      .map((c) =>
        this.state.schema.waterDischarged.subCols.map((s) => ({
          key: c.id + s.id,
          id: s.id,
          header: s.name,
        }))
      )
      .flat();
    waterDischargedSubHeaders.unshift(
      { key: 'label', header: 'Discharged Water' },
      { key: 'total', header: 'Total' }
    );

    const waterReusedHeaders = this.state.schema.waterReused.cols.map((c) => ({
      key: c.id,
      header: c.name,
    }));
    const waterReusedRows = this.state.schema.waterReused.rows.map((r) => {
      let total = 0;
      this.state.schema.waterReused.cols.forEach(
        (c) => (total += +this.state.waterReused[r.id][c.id] || 0)
      );
      return { id: r.id, label: r.name, total };
    });
    const grandTotalReused = waterReusedRows
      .map((w) => w.total)
      .reduce((acc, cur) => (acc += cur), 0);

    waterReusedHeaders.unshift(
      { key: 'label', header: 'Reused Water' },
      { key: 'total', header: 'Total' }
    );

    const waterDischargedValidations = {};
    this.state.schema.waterDischarged.rows.forEach((r) => {
      waterDischargedValidations[r.id] = {};
      this.state.schema.waterDischarged.cols.forEach((c) => {
        waterDischargedValidations[r.id][c.id] = {};
        this.state.schema.waterDischarged.subCols.forEach((s) => {
          waterDischargedValidations[r.id][c.id][s.id] = this.validator.message(
            `waterDischarged${r.id}${c.id}${s.id}`,
            this.state.waterDischarged[r.id][c.id][s.id],
            'geq'
          );
        });
      });
    });
    const waterReusedValidations = {};
    this.state.schema.waterReused.rows.forEach((r) => {
      waterReusedValidations[r.id] = {};
      this.state.schema.waterReused.cols.forEach((c) => {
        waterReusedValidations[r.id][c.id] = this.validator.message(
          `waterReused${r.id}${c.id}`,
          this.state.waterReused[r.id][c.id],
          'geq'
        );
      });
    });

    let isValid = true;
    for (const r of Object.keys(waterDischargedValidations)) {
      for (const c of Object.keys(waterDischargedValidations[r])) {
        for (const s of Object.keys(waterDischargedValidations[r][c])) {
          if (waterDischargedValidations[r][c][s] != null) {
            isValid = false;
            break;
          }
        }
        if (!isValid) break;
      }
      if (!isValid) break;
    }
    for (const r of Object.keys(waterReusedValidations)) {
      for (const c of Object.keys(waterReusedValidations[r])) {
        if (waterReusedValidations[r][c] != null) {
          isValid = false;
          break;
        }
        if (!isValid) break;
      }
      if (!isValid) break;
    }

    return (
      <Tab disabled={false} label="Water Discharged/Reused" className={isValid ? '' : 'with-error'}>
        <div className="datatable--information">
          <DataTable
            rows={waterDischargedRows || []}
            headers={waterDischargedSubHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        <TableHeader colSpan={2} />
                        {waterDischargedHeaders.map((header) => (
                          <TableHeader className="align-center" colSpan={2} key={header.key}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            {header.header !== 'Discharged Water' ? (
                              <div>
                                {' '}
                                {header.header} <p> m³ </p>
                              </div>
                            ) : (
                              header.header
                            )}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        rows.map((row) => (
                          <TableRow {...getRowProps({ row })}>
                            <td className="bx--cell">{row.cells[0].value}</td>
                            <td className="bx--cell center-vertically right-align">
                              {Math.round(row.cells[1].value * 100) / 100}
                            </td>
                            {waterDischargedHeaders.map((h) => (
                              <React.Fragment key={h.key}>
                                {this.state.schema.waterDischarged.subCols.map((s) => (
                                  <td className="bx--cell-input" key={s.id}>
                                    <TextInput
                                      className="cell--item"
                                      value={this.state.waterDischarged[row.id][h.key][s.id]}
                                      onChange={(e) =>
                                        this.onRowColSubcolInputChange(
                                          'waterDischarged',
                                          row.id,
                                          h.key,
                                          s.id,
                                          e
                                        )
                                      }
                                      type="number"
                                      min="0"
                                      invalid={
                                        waterDischargedValidations[row.id][h.key][s.id] != null
                                      }
                                    />
                                    {waterDischargedValidations[row.id][h.key][s.id]}
                                  </td>
                                ))}
                              </React.Fragment>
                            ))}
                          </TableRow>
                        ))
                      )}
                      <TableRow>
                        <td
                          colSpan={waterDischargedSubHeaders.length + 2}
                          className="bx--cell grand-total"
                        >
                          <h4>
                            Total:
                            {Math.round(grandTotalDischarged * 100) / 100}
                          </h4>
                        </td>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information">
          <DataTable
            rows={waterReusedRows || []}
            headers={waterReusedHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            {header.header !== 'Reused Water' ? (
                              <div>
                                {' '}
                                {header.header} <p> m³ </p>
                              </div>
                            ) : (
                              header.header
                            )}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        rows.map((row) => (
                          <TableRow {...getRowProps({ row })}>
                            <td className="bx--cell">{row.cells[0].value}</td>
                            <td className="bx--cell center-vertically right-align">
                              {Math.round(row.cells[1].value * 100) / 100}
                            </td>
                            {row.cells.slice(2).map((cell) => (
                              <td className="bx--cell-input" key={cell.id}>
                                <TextInput
                                  className="cell--item"
                                  value={this.state.waterReused[row.id][cell.info.header]}
                                  onChange={(e) =>
                                    this.onRowColInputChange(
                                      'waterReused',
                                      row.id,
                                      cell.info.header,
                                      e
                                    )
                                  }
                                  type="number"
                                  min="0"
                                  invalid={waterReusedValidations[row.id][cell.info.header] != null}
                                />
                                {waterReusedValidations[row.id][cell.info.header]}
                              </td>
                            ))}
                          </TableRow>
                        ))
                      )}
                      <TableRow>
                        <td
                          colSpan={waterReusedHeaders.length + 2}
                          className="bx--cell grand-total"
                        >
                          <h4>
                            Total:
                            {Math.round(grandTotalReused * 100) / 100}
                          </h4>
                        </td>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information notes">
          <FormGroup legendText="Notes">
            <TextArea
              maxLength={5000}
              id="waterDischargedReusedNotes"
              value={this.state.waterDischargedReusedNotes}
              onChange={this.onReportNotesChange}
              placeholder="Input Water Discharged/Reused Notes"
              hideLabel={true}
              labelText=""
              light
              rows={4}
              cols={100}
            />
          </FormGroup>
        </div>
      </Tab>
    );
  };

  renderHazardousWasteTab = () => {
    const wasteHazHeaders = this.state.schema.hazardousWaste.cols.map((c) => ({
      key: c.id,
      header: c.name,
    }));
    const wasteHazRows = this.state.schema.hazardousWaste.rows.map((r) => {
      let total = 0;
      this.state.schema.hazardousWaste.cols.forEach((c) => {
        total += +this.state.hazardousWaste[r.id][c.id].t || 0;
      });
      return { id: r.id, label: r.name, total };
    });
    const units = [
      { id: 'm3', header: 'm³' },
      { id: 't', header: 't' },
    ];
    const wasteHazSubHeaders = this.state.schema.hazardousWaste.cols
      .map((c) => units.map((s) => ({ key: c.id + s.id, id: s.id, header: s.header })))
      .flat();
    wasteHazSubHeaders.unshift(
      { key: 'label', header: 'Description' },
      { key: 'total', header: 't' }
    );
    const grandTotal = wasteHazRows.map((w) => w.total).reduce((acc, cur) => (acc += cur), 0);

    const hazardousWasteValidations = {};
    this.state.schema.hazardousWaste.rows.forEach((r) => {
      hazardousWasteValidations[r.id] = {};
      this.state.schema.hazardousWaste.cols.forEach((c) => {
        hazardousWasteValidations[r.id][c.id] = {};
        units.forEach((u) => {
          hazardousWasteValidations[r.id][c.id][u.id] = this.validator.message(
            `hazardousWaste${r.id}${c.id}${u.id}`,
            this.state.hazardousWaste[r.id][c.id][u.id],
            'geq'
          );
        });
      });
    });

    let isValid = true;
    for (const r of Object.keys(hazardousWasteValidations)) {
      for (const c of Object.keys(hazardousWasteValidations[r])) {
        for (const u of Object.keys(hazardousWasteValidations[r][c])) {
          if (hazardousWasteValidations[r][c][u] != null) {
            isValid = false;
            break;
          }
        }
        if (!isValid) break;
      }
      if (!isValid) break;
    }

    return (
      <Tab disabled={false} label="Hazardous Waste" className={isValid ? '' : 'with-error'}>
        <div className="datatable--information">
          <DataTable
            rows={wasteHazRows || []}
            headers={wasteHazSubHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        <TableHeader />
                        <TableHeader>Total</TableHeader>
                        {wasteHazHeaders.map((header) => (
                          <TableHeader colSpan={2} key={header.key}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        <>
                          {rows.map((row) => (
                            <TableRow {...getRowProps({ row })}>
                              <td className="bx--cell">{row.cells[0].value}</td>
                              <td className="bx--cell center-vertically right-align">
                                {Math.round(row.cells[1].value * 100) / 100}
                              </td>
                              {wasteHazHeaders.map((h) => (
                                <React.Fragment key={h.key}>
                                  {units.map((u) => (
                                    <td className="bx--cell-input" key={u.id}>
                                      <TextInput
                                        className="cell--item"
                                        value={this.state.hazardousWaste[row.id][h.key][u.id]}
                                        onChange={(e) =>
                                          this.onAutoConvertingInputChange(
                                            'hazardousWaste',
                                            row.id,
                                            h.key,
                                            u.id,
                                            e
                                          )
                                        }
                                        type="number"
                                        min="0"
                                        invalid={
                                          hazardousWasteValidations[row.id][h.key][u.id] != null
                                        }
                                      />
                                      {hazardousWasteValidations[row.id][h.key][u.id]}
                                    </td>
                                  ))}
                                </React.Fragment>
                              ))}
                            </TableRow>
                          ))}
                          <TableRow>
                            <td
                              colSpan={wasteHazSubHeaders.length + 2}
                              className="bx--cell grand-total"
                            >
                              <h4>
                                Total:
                                {Math.round(grandTotal * 100) / 100}
                              </h4>
                            </td>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information notes">
          <FormGroup legendText="Notes">
            <TextArea
              maxLength={5000}
              id="waterHazNotes"
              value={this.state.waterHazNotes}
              onChange={this.onReportNotesChange}
              placeholder="Input Hazardous Waste Notes"
              hideLabel={true}
              labelText=""
              light
              rows={4}
              cols={100}
            />
          </FormGroup>
        </div>
      </Tab>
    );
  };

  renderNonHazardousWasteTab = () => {
    const wasteNonHazHeaders = this.state.schema.nonHazardousWaste.cols.map((c) => ({
      key: c.id,
      header: c.name,
    }));
    const wasteNonHazRows = this.state.schema.nonHazardousWaste.rows.map((r) => {
      let total = 0;
      this.state.schema.nonHazardousWaste.cols.forEach((c) => {
        total += +this.state.nonHazardousWaste[r.id][c.id].t || 0;
      });
      return { id: r.id, label: r.name, total };
    });
    const units = [
      { id: 'm3', header: 'm³' },
      { id: 't', header: 't' },
    ];
    const wasteNonHazSubHeaders = this.state.schema.nonHazardousWaste.cols
      .map((c) => units.map((s) => ({ key: c.id + s.id, id: s.id, header: s.header })))
      .flat();
    wasteNonHazSubHeaders.unshift(
      { key: 'label', header: 'Description' },
      { key: 'total', header: 't' }
    );
    const grandTotal = wasteNonHazRows.map((w) => w.total).reduce((acc, cur) => (acc += cur), 0);

    const nonHazardousWasteValidations = {};
    this.state.schema.nonHazardousWaste.rows.forEach((r) => {
      nonHazardousWasteValidations[r.id] = {};
      this.state.schema.nonHazardousWaste.cols.forEach((c) => {
        nonHazardousWasteValidations[r.id][c.id] = {};
        units.forEach((u) => {
          nonHazardousWasteValidations[r.id][c.id][u.id] = this.validator.message(
            `nonHazardousWaste${r.id}${c.id}${u.id}`,
            this.state.nonHazardousWaste[r.id][c.id][u.id],
            'geq'
          );
        });
      });
    });

    let isValid = true;
    for (const r of Object.keys(nonHazardousWasteValidations)) {
      for (const c of Object.keys(nonHazardousWasteValidations[r])) {
        for (const u of Object.keys(nonHazardousWasteValidations[r][c])) {
          if (nonHazardousWasteValidations[r][c][u] != null) {
            isValid = false;
            break;
          }
        }
        if (!isValid) break;
      }
      if (!isValid) break;
    }

    return (
      <Tab disabled={false} label="Non Hazardous Waste" className={isValid ? '' : 'with-error'}>
        <div className="datatable--information">
          <DataTable
            rows={wasteNonHazRows || []}
            headers={wasteNonHazSubHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        <TableHeader />
                        <TableHeader>Total</TableHeader>
                        {wasteNonHazHeaders.map((header) => (
                          <TableHeader colSpan={2} key={header.key}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        <>
                          {rows.map((row) => (
                            <TableRow {...getRowProps({ row })}>
                              <td className="bx--cell">{row.cells[0].value}</td>
                              <td className="bx--cell center-vertically right-align">
                                {Math.round(row.cells[1].value * 100) / 100}
                              </td>
                              {wasteNonHazHeaders.map((h) => (
                                <React.Fragment key={h.key}>
                                  {units.map((u) => (
                                    <td className="bx--cell-input" key={u.id}>
                                      <TextInput
                                        className="cell--item"
                                        value={this.state.nonHazardousWaste[row.id][h.key][u.id]}
                                        onChange={(e) =>
                                          this.onAutoConvertingInputChange(
                                            'nonHazardousWaste',
                                            row.id,
                                            h.key,
                                            u.id,
                                            e
                                          )
                                        }
                                        type="number"
                                        min="0"
                                        invalid={
                                          nonHazardousWasteValidations[row.id][h.key][u.id] != null
                                        }
                                      />
                                      {nonHazardousWasteValidations[row.id][h.key][u.id]}
                                    </td>
                                  ))}
                                </React.Fragment>
                              ))}
                            </TableRow>
                          ))}
                          <TableRow>
                            <td
                              colSpan={wasteNonHazSubHeaders.length + 2}
                              className="bx--cell grand-total"
                            >
                              <h4>
                                Total:
                                {Math.round(grandTotal * 100) / 100}
                              </h4>
                            </td>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information notes">
          <FormGroup legendText="Notes">
            <TextArea
              maxLength={5000}
              id="waterNonHazNotes"
              value={this.state.waterNonHazNotes}
              onChange={this.onReportNotesChange}
              placeholder="Input Non Hazardous Waste Notes"
              hideLabel={true}
              labelText=""
              light
              rows={4}
              cols={100}
            />
          </FormGroup>
        </div>
      </Tab>
    );
  };

  renderWasteMonetizationTab = () => {
    // TODO
    const wasteMonetizationHeaders = this.state.schema.wasteMonetization.cols.map((c) => ({
      key: c.id,
      header: c.name,
    }));
    const hWasteMonetizationRows = this.state.schema.wasteMonetization.rows
      .filter((x) => x.idWasteHazardousType == 'Hazardous')
      .map((r) => ({
        id: r.id,
        label: r.name,
      }));
    const nhWasteMonetizationRows = this.state.schema.wasteMonetization.rows
      .filter((x) => x.idWasteHazardousType == 'Not Hazardous')
      .map((r) => ({
        id: r.id,
        label: r.name,
      }));
    const units = [
      { id: 'm3', header: 'm³' },
      { id: 't', header: 't' },
      { id: 'euro', header: '€' },
    ];
    const hWasteMonetizationSubHeaders = this.state.schema.wasteMonetization.cols
      .map((c) => units.map((s) => ({ key: c.id + s.id, id: s.id, header: s.header })))
      .flat();
    const nhWasteMonetizationSubHeaders = this.state.schema.wasteMonetization.cols
      .map((c) => units.map((s) => ({ key: c.id + s.id, id: s.id, header: s.header })))
      .flat();
    hWasteMonetizationSubHeaders.unshift({ key: 'label', header: 'Description - Hazardous Waste' });
    nhWasteMonetizationSubHeaders.unshift({
      key: 'label',
      header: 'Description - Non Hazardous Waste',
    });

    const wasteMonetizationValidations = {};
    this.state.schema.wasteMonetization.rows.forEach((r) => {
      wasteMonetizationValidations[r.id] = {};
      this.state.schema.wasteMonetization.cols.forEach((c) => {
        wasteMonetizationValidations[r.id][c.id] = {};
        units.forEach((u) => {
          wasteMonetizationValidations[r.id][c.id][u.id] = this.validator.message(
            `wasteMonetization${r.id}${c.id}${u.id}`,
            this.state.wasteMonetization[r.id][c.id][u.id],
            'geq'
          );
        });
      });
    });

    let isValid = true;
    for (const r of Object.keys(wasteMonetizationValidations)) {
      for (const c of Object.keys(wasteMonetizationValidations[r])) {
        for (const u of Object.keys(wasteMonetizationValidations[r][c])) {
          if (wasteMonetizationValidations[r][c][u] != null) {
            isValid = false;
            break;
          }
        }
        if (!isValid) break;
      }
      if (!isValid) break;
    }

    return (
      <Tab disabled={false} label="Waste Monetization" className={isValid ? '' : 'with-error'}>
        <div className="datatable--information">
          <DataTable
            rows={hWasteMonetizationRows || []}
            headers={hWasteMonetizationSubHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        <TableHeader />
                        {wasteMonetizationHeaders.map((header) => (
                          <TableHeader colSpan={3} key={header.key}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        <>
                          {rows.map((row) => (
                            <TableRow {...getRowProps({ row })}>
                              <td className="bx--cell">{row.cells[0].value}</td>
                              {wasteMonetizationHeaders.map((h) => (
                                <React.Fragment key={h.key}>
                                  {units.map((u) => (
                                    <td className="bx--cell-input" key={u.id}>
                                      <TextInput
                                        className="cell--item"
                                        value={this.state.wasteMonetization[row.id][h.key][u.id]}
                                        onChange={(e) =>
                                          this.onAutoConvertingInputChange(
                                            'wasteMonetization',
                                            row.id,
                                            h.key,
                                            u.id,
                                            e
                                          )
                                        }
                                        type="number"
                                        min="0"
                                        invalid={
                                          wasteMonetizationValidations[row.id][h.key][u.id] != null
                                        }
                                      />
                                      {wasteMonetizationValidations[row.id][h.key][u.id]}
                                    </td>
                                  ))}
                                </React.Fragment>
                              ))}
                            </TableRow>
                          ))}
                        </>
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
          <br></br>
          <br></br>
          <DataTable
            rows={nhWasteMonetizationRows || []}
            headers={nhWasteMonetizationSubHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        <TableHeader />
                        {wasteMonetizationHeaders.map((header) => (
                          <TableHeader colSpan={3} key={header.key}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        <>
                          {rows.map((row) => (
                            <TableRow {...getRowProps({ row })}>
                              <td className="bx--cell">{row.cells[0].value}</td>
                              {wasteMonetizationHeaders.map((h) => (
                                <React.Fragment key={h.key}>
                                  {units.map((u) => (
                                    <td className="bx--cell-input" key={u.id}>
                                      <TextInput
                                        className="cell--item"
                                        value={this.state.wasteMonetization[row.id][h.key][u.id]}
                                        onChange={(e) =>
                                          this.onAutoConvertingInputChange(
                                            'wasteMonetization',
                                            row.id,
                                            h.key,
                                            u.id,
                                            e
                                          )
                                        }
                                        type="number"
                                        min="0"
                                        invalid={
                                          wasteMonetizationValidations[row.id][h.key][u.id] != null
                                        }
                                      />
                                      {wasteMonetizationValidations[row.id][h.key][u.id]}
                                    </td>
                                  ))}
                                </React.Fragment>
                              ))}
                            </TableRow>
                          ))}
                        </>
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information notes">
          <FormGroup legendText="Notes">
            <TextArea
              maxLength={5000}
              id="wasteMonetizationNotes"
              value={this.state.wasteMonetizationNotes}
              onChange={this.onReportNotesChange}
              placeholder="Input Waste Monetization Notes"
              hideLabel={true}
              labelText=""
              light
              rows={4}
              cols={100}
            />
          </FormGroup>
        </div>
      </Tab>
    );
  };

  renderEnergyBySourceTab = () => {
    const energyBySourceHeaders = this.state.schema.energyAccounting.cols.map((w) => ({
      key: w.id,
      header: w.name,
    }));
    energyBySourceHeaders.unshift(
      { key: 'label', header: 'Source' },
      { key: 'unit', header: 'Units' },
      { key: 'total', header: 'Total' }
    );
    const energyBySourceRows = this.state.schema.energyAccounting.rows
      .filter((r) => !r.informativeonly)
      .map((r) => {
        let total = 0;
        this.state.schema.energyAccounting.cols.forEach(
          (c) => (total += +this.state.energyBySource[r.id][c.id] || 0)
        );
        return {
          id: r.id,
          label: r.name,
          total,
          unit: r.name === 'Natural gas(methane)' ? 'NM3' : 'TON',
        };
      });
    const grandTotal = energyBySourceRows.map((w) => w.total).reduce((acc, cur) => (acc += cur), 0);

    const energyBySourceInformativeHeaders = [
      { key: 'label', header: 'Source' },
      { key: 'unit', header: 'Units' },
      {
        key: this.state.schema.energyAccounting.cols.filter((c) => (c.Name = 'Other'))[0].id,
        header: 'Total',
      },
    ];
    const energyBySourceInformativeRows = this.state.schema.energyAccounting.rows
      .filter((r) => r.informativeonly)
      .map((r) => ({ id: r.id, label: r.name, unit: 'KWh', total: null }));

    const energyAccountingValidations = {};
    this.state.schema.energyAccounting.rows.forEach((r) => {
      energyAccountingValidations[r.id] = {};
      this.state.schema.energyAccounting.cols.forEach((c) => {
        energyAccountingValidations[r.id][c.id] = this.validator.message(
          `energyAccounting${r.id}${c.id}`,
          this.state.energyBySource[r.id][c.id],
          'geq'
        );
      });
    });

    let isValid = true;
    for (const r of Object.keys(energyAccountingValidations)) {
      for (const c of Object.keys(energyAccountingValidations[r])) {
        if (energyAccountingValidations[r][c] != null) {
          isValid = false;
          break;
        }
      }
      if (!isValid) break;
    }

    return (
      <Tab disabled={false} label="Energy Accounting" className={isValid ? '' : 'with-error'}>
        <div className="datatable--information">
          <DataTable
            rows={energyBySourceRows || []}
            headers={energyBySourceHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            <div> {header.header} </div>
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        <>
                          {rows.map((row) => (
                            <TableRow {...getRowProps({ row })}>
                              <td className="bx--cell">{row.cells[0].value}</td>
                              <td className="bx--cell center-vertically">{row.cells[1].value}</td>
                              <td className="bx--cell center-vertically right-align">
                                {Math.round(row.cells[2].value * 100) / 100}
                              </td>
                              {row.cells.slice(3).map((cell) => (
                                <td className="bx--cell-input" key={cell.id}>
                                  <TextInput
                                    className="cell--item"
                                    value={this.state.energyBySource[row.id][cell.info.header]}
                                    onChange={(e) => {
                                      this.onRowColInputChange(
                                        'energyBySource',
                                        row.id,
                                        cell.info.header,
                                        e
                                      );
                                    }}
                                    type="number"
                                    min="0"
                                    invalid={
                                      energyAccountingValidations[row.id][cell.info.header] != null
                                    }
                                  />
                                  {energyAccountingValidations[row.id][cell.info.header]}
                                </td>
                              ))}
                            </TableRow>
                          ))}
                          <TableRow>
                            <td colSpan={10} className="bx--cell grand-total">
                              <h4>
                                Total:
                                {Math.round(grandTotal * 100) / 100}
                              </h4>
                            </td>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information">
          <DataTable
            rows={energyBySourceInformativeRows || []}
            headers={energyBySourceInformativeHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            <div> {header.header} </div>
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        rows.map((row) => (
                          <TableRow {...getRowProps({ row })}>
                            <td className="bx--cell">{row.cells[0].value}</td>
                            <td className="bx--cell center-vertically right-align">
                              {row.cells[1].value}
                            </td>
                            {row.cells.slice(2).map((cell) => (
                              <td className="bx--cell-input" key={cell.id}>
                                <TextInput
                                  className="cell--item"
                                  value={this.state.energyBySource[row.id][cell.info.header]}
                                  onChange={(e) =>
                                    this.onRowColInputChange(
                                      'energyBySource',
                                      row.id,
                                      cell.info.header,
                                      e
                                    )
                                  }
                                  type="number"
                                  min="0"
                                  invalid={
                                    energyAccountingValidations[row.id][cell.info.header] != null
                                  }
                                />
                                {energyAccountingValidations[row.id][cell.info.header]}
                              </td>
                            ))}
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information notes">
          <FormGroup legendText="Notes">
            <TextArea
              maxLength={5000}
              id="energySourceNotes"
              value={this.state.energySourceNotes}
              onChange={this.onReportNotesChange}
              placeholder="Input Energy Accounting Notes"
              hideLabel={true}
              labelText=""
              light
              rows={4}
              cols={100}
            />
          </FormGroup>
        </div>
        <div>
          <EnergyAccountLeasedAssetList
            leasedAssetHeaders={energyBySourceHeaders}
            leasedAssetInformativeHeaders={energyBySourceInformativeHeaders}
            leasedAssetSchema={this.state.schema.energyAccounting}
            buildTwoLevelStructure={this.buildTwoLevelStructure}
            report={this.state.report}
            idReport={this.props.match.params.idReport}
            idReportEnvironment={this.state.report?.idReportEnvironment} 
          />
        </div>
      </Tab>
    );
  };

  renderOilSpillTab = () => {
    const oilSpillHeaders = this.state.schema.oilSpill.cols
      .filter((x) => x.idSpillType === 'Oil Spill')
      .map((c) => ({ key: c.id, header: c.name }));
    const oilSpillRows = this.state.schema.oilSpill.rows.map((r) => ({ id: r.id, label: r.name }));

    const units = [
      { id: 'n', header: 'Number' },
      { id: 'm3', header: 'Volume (m³ )' },
    ];

    const oilSpillSubHeaders = this.state.schema.oilSpill.cols
      .filter((x) => x.idSpillType === 'Oil Spill')
      .map((c) => units.map((s) => ({ key: c.id + s.id, id: s.id, header: s.header })))
      .flat();
    oilSpillSubHeaders.unshift({ key: 'label', header: 'Spill' });

    const totals = [];
    this.state.schema.oilSpill.cols
      .filter((x) => x.idSpillType === 'Oil Spill')
      .forEach((c) => {
        units.forEach((u) => {
          let total = 0;
          this.state.schema.oilSpill.rows.forEach((r) => {
            total += +this.state.oilSpill[r.id][c.id][u.id] || 0;
          });
          totals.push(total);
        });
      });

    const secondaryTableHeaders = [
      { key: 'key', header: '' },
      { key: 'label', header: '' },
    ];
    const secondaryTableRows = [
      {
        id: 0,
        key: 'oilSpillNumberEnvSampling',
        label: 'Number of environmental samplings/monitorings after the spill',
      },
      { id: 1, key: 'oilSpillRecoveredVolum', label: 'Recovered contaminated volume (m³)' },
    ];

    const existentOfOilResponsePlan = {
      id: 0,
      key: 'oilSpillExistentOilResponse',
      label: 'Existent of Oil response Plan/Procedure',
    };

    const oilSpillValidations = {};
    this.state.schema.oilSpill.rows.forEach((r) => {
      oilSpillValidations[r.id] = {};
      this.state.schema.oilSpill.cols.forEach((c) => {
        oilSpillValidations[r.id][c.id] = {};
        units.forEach((u) => {
          oilSpillValidations[r.id][c.id][u.id] = this.validator.message(
            `oilSpill${r.id}${c.id}${u.id}`,
            this.state.oilSpill[r.id][c.id][u.id],
            'geq'
          );
        });
      });
    });

    let isValid = true;
    for (const r of Object.keys(oilSpillValidations)) {
      for (const c of Object.keys(oilSpillValidations[r])) {
        for (const u of Object.keys(oilSpillValidations[r][c])) {
          if (oilSpillValidations[r][c][u] != null) {
            isValid = false;
            break;
          }
        }
        if (!isValid) break;
      }
      if (!isValid) break;
    }
    oilSpillValidations.oilSpillNumberEnvSampling = this.validator.message(
      'oilSpillNumberEnvSampling',
      this.state.oilSpillNumberEnvSampling,
      'geq'
    );
    oilSpillValidations.oilSpillRecoveredVolum = this.validator.message(
      'oilSpillRecoveredVolum',
      this.state.oilSpillRecoveredVolum,
      'geq'
    );
    if (
      oilSpillValidations.oilSpillNumberEnvSampling != null ||
      oilSpillValidations.oilSpillRecoveredVolum != null
    ) {
      isValid = false;
    }

    return (
      <Tab disabled={false} label="Spill" className={isValid ? '' : 'with-error'}>
        <div className="datatable--information">
          <DataTable
            rows={oilSpillRows || []}
            headers={oilSpillSubHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        <TableHeader />
                        {oilSpillHeaders.map((header) => (
                          <TableHeader colSpan={2} key={header.key}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        <>
                          {rows.map((row) => (
                            <TableRow {...getRowProps({ row })}>
                              <td className="bx--cell">{row.cells[0].value}</td>
                              {oilSpillHeaders.map((h) => (
                                <React.Fragment key={h.key}>
                                  {units.map((u) => (
                                    <td className="bx--cell-input" key={u.id}>
                                      <TextInput
                                        className="cell--item"
                                        value={this.state.oilSpill[row.id][h.key][u.id]}
                                        onChange={(e) =>
                                          this.onRowColSubcolInputChange(
                                            'oilSpill',
                                            row.id,
                                            h.key,
                                            u.id,
                                            e
                                          )
                                        }
                                        type="number"
                                        min="0"
                                        invalid={oilSpillValidations[row.id][h.key][u.id] != null}
                                      />
                                      {oilSpillValidations[row.id][h.key][u.id]}
                                    </td>
                                  ))}
                                </React.Fragment>
                              ))}
                            </TableRow>
                          ))}
                          <TableRow>
                            <td className="bx--cell">Total</td>
                            {totals.map((t) => (
                              <td className="bx--cell right-align">{Math.round(t * 100) / 100}</td>
                            ))}
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information secondary">
          <DataTable
            rows={secondaryTableRows || []}
            headers={secondaryTableHeaders || []}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        <>
                          {rows.map((row) => (
                            <TableRow {...getRowProps({ row })}>
                              <td className="bx--cell">{row.cells[1].value}</td>
                              <td className="bx--cell center-vertically">
                                <TextInput
                                  className="cell--item"
                                  value={this.state[row.cells[0].value]}
                                  onChange={(e) => this.onSimpleInputChange(row.cells[0].value, e)}
                                  type="number"
                                  min="0"
                                  invalid={oilSpillValidations[row.cells[0].value] != null}
                                />
                                {oilSpillValidations[row.cells[0].value]}
                              </td>
                            </TableRow>
                          ))}
                        </>
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>

        <div className="datatable--information secondary">
          <DataTable
            rows={[existentOfOilResponsePlan] || []}
            headers={secondaryTableHeaders || []}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableBody>
                      <TableRow>
                        <td className="bx--cell">{existentOfOilResponsePlan.label}</td>
                        <td className="bx--cell center-vertically">
                          <RadioButtonGroup
                            labelPosition="right"
                            legend=""
                            name="existenceOfOilResponsePlan"
                            onChange={this.handleRadioChange}
                            orientation="horizontal"
                            valueSelected={
                              this.state[existentOfOilResponsePlan.key] != null
                                ? this.state[existentOfOilResponsePlan.key].toString()
                                : ''
                            }
                          >
                            <RadioButton id="planExists" value="true" labelText="Yes" alt="model" />
                            <RadioButton
                              id="planDoesNotExist"
                              value="false"
                              labelText="No"
                              alt="model"
                            />
                          </RadioButtonGroup>
                        </td>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>
        <div className="datatable--information notes">
          <FormGroup legendText="Notes">
            <TextArea
              maxLength={5000}
              id="oilSpillNotes"
              value={this.state.oilSpillNotes}
              onChange={this.onReportNotesChange}
              placeholder="Input Spill Notes"
              hideLabel={true}
              labelText=""
              light
              rows={4}
              cols={100}
            />
          </FormGroup>
        </div>
      </Tab>
    );
  };

  renderChemicalSpillTab = () => {
    const chemicalSpillHeaders = this.state.schema.chemicalSpill.cols
      .filter((x) => x.idSpillType === 'Chemical spill')
      .map((c) => ({ key: c.id, header: c.name }));
    const chemicalSpillRows = this.state.schema.chemicalSpill.rows.map((r) => ({
      id: r.id,
      label: r.name,
    }));

    const units = [
      { id: 'n', header: 'Number' },
      { id: 'm3', header: 'Volume (m³)' },
    ];

    const chemicalSpillSubHeaders = this.state.schema.chemicalSpill.cols
      .filter((x) => x.idSpillType === 'Chemical spill')
      .map((c) => units.map((s) => ({ key: c.id + s.id, id: s.id, header: s.header })))
      .flat();
    chemicalSpillSubHeaders.unshift({ key: 'label', header: 'Near Miss' });

    const totals = [];
    this.state.schema.chemicalSpill.cols
      .filter((x) => x.idSpillType === 'Chemical spill')
      .forEach((c) => {
        units.forEach((u) => {
          let total = 0;
          this.state.schema.chemicalSpill.rows.forEach((r) => {
            total += +this.state.chemicalSpill[r.id][c.id][u.id] || 0;
          });
          totals.push(total);
        });
      });

    const secondaryTableHeaders = [
      { key: 'key', header: '' },
      { key: 'label', header: '' },
    ];
    const secondaryTableRows = [
      {
        id: 0,
        key: 'chemicalSpillNumberEnvSampling',
        label: 'Number of environmental samplings/monitorings after the spill',
      },
      { id: 1, key: 'chemicalSpillRecoveredVolum', label: 'Recovered contaminated volume (m³)' },
    ];

    const chemicalSpillValidations = {};
    this.state.schema.chemicalSpill.rows.forEach((r) => {
      chemicalSpillValidations[r.id] = {};
      this.state.schema.chemicalSpill.cols.forEach((c) => {
        chemicalSpillValidations[r.id][c.id] = {};
        units.forEach((u) => {
          chemicalSpillValidations[r.id][c.id][u.id] = this.validator.message(
            `chemicalSpill${r.id}${c.id}${u.id}`,
            this.state.chemicalSpill[r.id][c.id][u.id],
            'geq'
          );
        });
      });
    });

    let isValid = true;
    for (const r of Object.keys(chemicalSpillValidations)) {
      for (const c of Object.keys(chemicalSpillValidations[r])) {
        for (const u of Object.keys(chemicalSpillValidations[r][c])) {
          if (chemicalSpillValidations[r][c][u] != null) {
            isValid = false;
            break;
          }
        }
        if (!isValid) break;
      }
      if (!isValid) break;
    }
    chemicalSpillValidations.chemicalSpillNumberEnvSampling = this.validator.message(
      'chemicalSpillNumberEnvSampling',
      this.state.chemicalSpillNumberEnvSampling,
      'geq'
    );
    chemicalSpillValidations.chemicalSpillRecoveredVolum = this.validator.message(
      'chemicalSpillRecoveredVolum',
      this.state.chemicalSpillRecoveredVolum,
      'geq'
    );
    if (
      chemicalSpillValidations.chemicalSpillNumberEnvSampling != null ||
      chemicalSpillValidations.chemicalSpillRecoveredVolum != null
    ) {
      isValid = false;
    }

    return (
      <Tab disabled={false} label="Near Miss" className={isValid ? '' : 'with-error'}>
        <div className="datatable--information">
          <DataTable
            rows={chemicalSpillRows || []}
            headers={chemicalSpillSubHeaders}
            useZebraStyles
            render={({ rows, headers, getHeaderProps, getRowProps }) => (
              <TableContainer className="bx--grid--full-width">
                {this.state.isLoadingList ? (
                  <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                ) : (
                  <Table>
                    <TableHead className="colorgray">
                      <TableRow>
                        <TableHeader />
                        {chemicalSpillHeaders.map((header) => (
                          <TableHeader colSpan={2} key={header.key}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                      <TableRow>
                        {headers.map((header) => (
                          <TableHeader
                            className={header.type === 'bool' ? 'align-center' : ''}
                            {...getHeaderProps({ header })}
                          >
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 1} />
                      ) : (
                        <>
                          {rows.map((row) => (
                            <TableRow {...getRowProps({ row })}>
                              <td className="bx--cell">{row.cells[0].value}</td>
                              {chemicalSpillHeaders.map((h) => (
                                <React.Fragment key={h.key}>
                                  {units.map((u) => (
                                    <td className="bx--cell-input" key={u.id}>
                                      <TextInput
                                        className="cell--item"
                                        value={this.state.chemicalSpill[row.id][h.key][u.id]}
                                        onChange={(e) =>
                                          this.onRowColSubcolInputChange(
                                            'chemicalSpill',
                                            row.id,
                                            h.key,
                                            u.id,
                                            e
                                          )
                                        }
                                        type="number"
                                        min="0"
                                        invalid={
                                          chemicalSpillValidations[row.id][h.key][u.id] != null
                                        }
                                      />
                                      {chemicalSpillValidations[row.id][h.key][u.id]}
                                    </td>
                                  ))}
                                </React.Fragment>
                              ))}
                            </TableRow>
                          ))}
                          <TableRow>
                            <td className="bx--cell">Total</td>
                            {totals.map((t) => (
                              <td className="bx--cell right-align">{Math.round(t * 100) / 100}</td>
                            ))}
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            )}
          />
        </div>

        <div className="datatable--information notes">
          <FormGroup legendText="Notes">
            <TextArea
              maxLength={5000}
              id="chemicalSpillNotes"
              value={this.state.chemicalSpillNotes}
              onChange={this.onReportNotesChange}
              placeholder="Input Near Miss Notes"
              hideLabel={true}
              labelText=""
              light
              rows={4}
              cols={100}
            />
          </FormGroup>
        </div>
        {/* <div className="datatable--information secondary">
                    <DataTable
                        rows={secondaryTableRows || []}
                        headers={secondaryTableHeaders || []}
                        useZebraStyles={true}
                        render={({ rows, headers, getHeaderProps, getRowProps }) => (
                            <TableContainer className="bx--grid--full-width" >
                                {this.state.isLoadingList ?
                                    <DataTableSkeleton headers={[]} zebra={false} compact={false} />
                                    :
                                    <Table>
                                        <TableBody>
                                            {
                                                (rows == null || rows.length == 0)
                                                    ?
                                                    <NoRecordsPlaceholder colSpan={headers.length + 1} />
                                                    :
                                                    <>
                                                        {
                                                            rows.map(row => (
                                                                <TableRow {...getRowProps({ row })}>
                                                                    <td className="bx--cell"> 
                                                                        {row.cells[1].value}
                                                                    </td>
                                                                    <td className="bx--cell center-vertically">
                                                                        <TextInput className="cell--item"
                                                                            value={this.state[row.cells[0].value]}
                                                                            onChange={e => this.onSimpleInputChange(row.cells[0].value, e)}
                                                                            type="number"
                                                                            min="0"
                                                                            invalid={chemicalSpillValidations[row.cells[0].value] != null}
                                                                        />
                                                                        { chemicalSpillValidations[row.cells[0].value] }
                                                                    </td>
                                                                </TableRow>
                                                            ))
                                                        }
                                                    </>
                                            }
                                        </TableBody>
                                    </Table>
                                }
                            </TableContainer>
                        )}
                    />

                </div> */}
      </Tab>
    );
  };

  render() {
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo={`/reportSummaries/${this.props.match.params.idReportSummary}`}
              linkText="Report Summary"
              titleLeft="Report Environment"
              titleCenter={this.state.report && `ID: ${this.state.report.progressiveId}`}
              titleRight={this.state.report && this.state.report.status}
              showButtonHistory={this.showButtonHistory()}
            />
            <div className="mainContainer">
              {!this.state.isLoading ? (
                <HistoryTable
                  entityId={this.state.report.id}
                  isOpenModal={this.state.isHistoryModalOpen}
                  onClose={() => this.closeModalHistory()}
                />
              ) : (
                ''
              )}
              <div className="bx--grid">
                {this.state.isLoading ? (
                  <CodeSnippetSkeleton type="multi" />
                ) : (
                  <div className="box--informations-all">
                    <div className="box-information-button">
                      <Button
                        className="button-actions-table"
                        size="default"
                        renderIcon={Info16}
                        onClick={this.showDivInfo}
                        iconDescription="show information"
                        tooltipPosition="top"
                        tooltipAlignment="end"
                        hasIconOnly
                      />
                    </div>

                    {this.divInfo()}
                  </div>
                )}
                <div className="bx--row mt-30">
                  <div className="bx--col box-modal-content-costum-title">
                    <TableToolbar>
                      <div className="bx--col-lg-12 bx--col-md-12 button--items box-modal-content-costum-title">
                        <Button
                          renderIcon={Save16}
                          className="pull--right"
                          onClick={() => this.submitReport(false)}
                          disabled={this.state.isLoadingSubmitted}
                        >
                          {this.state.isSubmitted ? (
                            <span>Save</span>
                          ) : (
                            <InlineLoading className="short-loader" />
                          )}
                        </Button>
                      </div>
                    </TableToolbar>
                  </div>
                </div>
                {this.state.isInvalid && !this.validator.allValid() ? (
                  <div className="bx--row mt-20">
                    <div className="bx--col">
                      <p className="srv-validation-message pull--right">
                        Some tabs contain erroneous fields
                      </p>
                    </div>
                  </div>
                ) : null}
                <div className="bx--row tabs--custom report-tabs environment">
                  {this.state.isLoading ? (
                    <DataTableSkeleton headers={[]} rowCount={10} zebra={false} compact={false} />
                  ) : (
                    <Tabs tabContentClassName="bx-table-all-view tabs--custom-content">
                      {this.renderWaterBySourceTab()}
                      {this.renderWaterDischargedReusedTab()}
                      {this.renderHazardousWasteTab()}
                      {this.renderNonHazardousWasteTab()}
                      {this.renderWasteMonetizationTab()}
                      {this.renderEnergyBySourceTab()}
                      {this.renderOilSpillTab()}
                      {this.renderChemicalSpillTab()}
                    </Tabs>
                  )}
                </div>
              </div>
            </div>
            {this.state.isWarningModalOpen ? (
              <WarningModal
                message="Some fields are empty. If you choose to continue, all such fields will be set to zero."
                onCancel={this.toggleWarningModal}
                onConfirm={this.handleConfirmSubmit}
              />
            ) : null}
          </>
        )}
      </AppContext.Consumer>
    );
  }

  toggleWarningModal = () => {
    this.setState((prevState) => ({
      isWarningModalOpen: !prevState.isWarningModalOpen,
    }));
  };

  handleConfirmSubmit = () => {
    this.setState(
      {
        isWarningModalOpen: false,
      },
      () => this.submitReport(true)
    );
  };

  destructureWaterData(obj, fillEmptyFields) {
    const result = [];
    let containsEmptyFields = false;
    Object.keys(obj).forEach((key1) => {
      Object.keys(obj[key1]).forEach((key2) => {
        if (!fillEmptyFields && (obj[key1][key2] === undefined || obj[key1][key2] === '')) {
          containsEmptyFields = true;
        } else {
          obj[key1][key2] = obj[key1][key2] || 0;
          result.push({
            idWaterSourceType: key1,
            idWaterUsageType: key2,
            idReportEnvironment: this.state.report.idReportEnvironment,
            valueM3: obj[key1][key2],
          });
        }
      });
    });
    return containsEmptyFields ? null : result;
  }

  destructureThreeLevelsData(obj, fillEmptyFields) {
    const result = [];
    let containsEmptyFields = false;
    Object.keys(obj).forEach((key1) => {
      Object.keys(obj[key1]).forEach((key2) => {
        Object.keys(obj[key1][key2]).forEach((key3) => {
          if (
            !fillEmptyFields &&
            (obj[key1][key2][key3] === undefined || obj[key1][key2][key3] === '')
          ) {
            containsEmptyFields = true;
          } else {
            obj[key1][key2][key3] = obj[key1][key2][key3] || 0;
            result.push({
              idWaterSourceType: key1,
              idWaterDischargeType: key2,
              idWaterDischargeTreatment: key3,
              idReportEnvironment: this.state.report.idReportEnvironment,
              valueM3: obj[key1][key2][key3],
            });
          }
        });
      });
    });
    return containsEmptyFields ? null : result;
  }

  destructureEnergyData(obj, fillEmptyFields) {
    const result = [];
    let containsEmptyFields = false;
    Object.keys(obj).forEach((key1) => {
      Object.keys(obj[key1]).forEach((key2) => {
        if (!fillEmptyFields && (obj[key1][key2] === undefined || obj[key1][key2] === '')) {
          containsEmptyFields = true;
        } else {
          obj[key1][key2] = obj[key1][key2] || 0;
          result.push({
            idEnergySourceType: key1,
            idEnergyUsageType: key2,
            idReportEnvironment: this.state.report.idReportEnvironment,
            value: obj[key1][key2],
          });
        }
      });
    });
    return containsEmptyFields ? null : result;
  }

  destructureWasteData(obj, fillEmptyFields) {
    const result = [];
    let containsEmptyFields = false;
    Object.keys(obj).forEach((key1) => {
      Object.keys(obj[key1]).forEach((key2) => {
        if (
          !fillEmptyFields &&
          (obj[key1][key2].m3 === undefined ||
            obj[key1][key2].m3 === '' ||
            obj[key1][key2].t === undefined ||
            obj[key1][key2].t === '')
        ) {
          containsEmptyFields = true;
        } else {
          obj[key1][key2].m3 = obj[key1][key2].m3 || 0;
          obj[key1][key2].t = obj[key1][key2].t || 0;
          result.push({
            idWasteType: key1,
            idWasteTreatment: key2,
            idReportEnvironment: this.state.report.idReportEnvironment,
            valueM3: obj[key1][key2].m3,
            valueT: obj[key1][key2].t,
          });
        }
      });
    });
    return containsEmptyFields ? null : result;
  }

  destructureWasteMonetizationData(obj, fillEmptyFields) {
    const result = [];
    let containsEmptyFields = false;
    Object.keys(obj).forEach((key1) => {
      Object.keys(obj[key1]).forEach((key2) => {
        if (
          !fillEmptyFields &&
          (obj[key1][key2].m3 === undefined ||
            obj[key1][key2].m3 === '' ||
            obj[key1][key2].t === undefined ||
            obj[key1][key2].t === '' ||
            obj[key1][key2].euro === undefined ||
            obj[key1][key2].euro === '')
        ) {
          containsEmptyFields = true;
        } else {
          obj[key1][key2].m3 = obj[key1][key2].m3 || 0;
          if (obj[key1][key2].m3 === 0) obj[key1][key2].t = obj[key1][key2].t || 0;
          obj[key1][key2].euro = obj[key1][key2].euro || 0;
          result.push({
            idWasteType: key1,
            idWasteMonetization: key2,
            idReportEnvironment: this.state.report.idReportEnvironment,
            valueM3: obj[key1][key2].m3,
            valueT: obj[key1][key2].t,
            valueEuro: obj[key1][key2].euro,
          });
        }
      });
    });
    return containsEmptyFields ? null : result;
  }

  destructureSpillData(obj, fillEmptyFields) {
    const result = [];
    let containsEmptyFields = false;
    Object.keys(obj).forEach((key1) => {
      Object.keys(obj[key1]).forEach((key2) => {
        if (
          !fillEmptyFields &&
          (obj[key1][key2].m3 === undefined ||
            obj[key1][key2].m3 === '' ||
            obj[key1][key2].n === undefined ||
            obj[key1][key2].n === '')
        ) {
          containsEmptyFields = true;
        } else {
          obj[key1][key2].n = obj[key1][key2].n || 0;
          obj[key1][key2].m3 = obj[key1][key2].m3 || 0;
          result.push({
            idSpillValueRange: key1,
            idSpillDestination: key2,
            idReportEnvironment: this.state.report.idReportEnvironment,
            valueN: obj[key1][key2].n,
            valueM3: obj[key1][key2].m3,
          });
        }
      });
    });
    return containsEmptyFields ? null : result;
  }

  submitReport = (fillEmptyFields) => {
    if (this.validator.allValid()) {
      this.setState({ isInvalid: false });
      // Destructure data in order to make it compatible with BE DTO types
      const waterBySource = this.destructureWaterData(this.state.waterBySource, fillEmptyFields);
      const waterDischarged = this.destructureThreeLevelsData(
        this.state.waterDischarged,
        fillEmptyFields
      );
      const waterReused = this.destructureWaterData(this.state.waterReused, fillEmptyFields);
      const hazardousWaste = this.destructureWasteData(this.state.hazardousWaste, fillEmptyFields);
      const nonHazardousWaste = this.destructureWasteData(
        this.state.nonHazardousWaste,
        fillEmptyFields
      );
      const wasteMonetization = this.destructureWasteMonetizationData(
        this.state.wasteMonetization,
        fillEmptyFields
      );
      const energyBySource = this.destructureEnergyData(this.state.energyBySource, fillEmptyFields);
      const oilSpill = this.destructureSpillData(this.state.oilSpill, fillEmptyFields);
      const chemicalSpill = this.destructureSpillData(this.state.chemicalSpill, fillEmptyFields);

      const dataList = [
        waterBySource,
        waterDischarged,
        waterReused,
        hazardousWaste,
        nonHazardousWaste,
        wasteMonetization,
        energyBySource,
        oilSpill,
        chemicalSpill,
      ];
      const standaloneFields = [
        this.state.oilSpillNumberEnvSampling,
        this.state.oilSpillRecoveredVolum,
        this.state.chemicalSpillNumberEnvSampling,
        this.state.chemicalSpillRecoveredVolum,
        this.state.bottleWater,
      ];

      if (fillEmptyFields) {
        this.setState((prevState) => ({
          oilSpillNumberEnvSampling: prevState.oilSpillNumberEnvSampling || 0,
          oilSpillRecoveredVolum: prevState.oilSpillRecoveredVolum || 0,
          chemicalSpillNumberEnvSampling: prevState.chemicalSpillNumberEnvSampling || 0,
          chemicalSpillRecoveredVolum: prevState.chemicalSpillRecoveredVolum || 0,
          bottleWater: prevState.bottleWater || 0,
        }));
      }

      const containEmptyFields =
        !fillEmptyFields &&
        (dataList.some((e) => e === null) || standaloneFields.some((e) => e == null || e === ''));

      if (containEmptyFields) {
        this.toggleWarningModal();
        return;
      }

      const dto = {
        waterSourceReportData: waterBySource,
        waterDischargedReportData: waterDischarged,
        waterReusedReportData: waterReused,
        wasteHazReportData: hazardousWaste,
        wasteNonHazReportData: nonHazardousWaste,
        wasteMonetizationReportData: wasteMonetization,
        energySourceReportData: energyBySource,
        oilSpillReportData: oilSpill,
        chemicalSpillReportData: chemicalSpill,

        // standalone fields
        oilSpillExistentOilResponse: this.state.oilSpillExistentOilResponse || false,
        oilSpillNumberEnvSampling: this.state.oilSpillNumberEnvSampling || 0,
        oilSpillRecoveredVolum: this.state.oilSpillRecoveredVolum || 0,
        chemicalSpillNumberEnvSampling: this.state.chemicalSpillNumberEnvSampling || 0,
        chemicalSpillRecoveredVolum: this.state.chemicalSpillRecoveredVolum || 0,
        bottleWater: this.state.bottleWater || 0,

        //Notes
        waterSourceNotes: this.state.waterSourceNotes,
        waterDischargedReusedNotes: this.state.waterDischargedReusedNotes,
        waterHazNotes: this.state.waterHazNotes,
        waterNonHazNotes: this.state.waterNonHazNotes,
        energySourceNotes: this.state.energySourceNotes,
        oilSpillNotes: this.state.oilSpillNotes,
        chemicalSpillNotes: this.state.chemicalSpillNotes,
        wasteMonetizationNotes: this.state.wasteMonetizationNotes,
      };

      this.setState({ isSubmitted: false, isLoadingSubmitted: true });
      api
        .put('reports/environment/', dto, this.props.match.params.idReport)
        .then((response) => {
          ReportRepository.updateCachedEnvironment(this.props.match.params.idReport, dto);
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.ENVIROMENT, apioperation.PUT)
          );
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.ENVIROMENT, apioperation.PUT)
          );
        })
        .finally(() => {
          this.setState({
            isSubmitted: true,
            isLoadingSubmitted: false,
          });
        });
    } else {
      this.validator.showMessages();
      this.setState({ isInvalid: true });
    }
  };
}
